import { Box, Typography } from "@mui/material";
import { NavLink } from "react-router-dom";
import {
  AllStudiesIcon,
  FeaturesIcon,
  HomeIcon,
  InstrumentLibraryIcon,
  Logo,
  MahaloIcon,
  PlatformUsersIcon,
} from "../Common/assets/Sidebar";
import VersionWrapper from "../Common/UI/VersionWrapper";
import { useAppSelector } from "../../Redux/hooks";
import { platformAdminPermissions } from "../../utils/roles";
import { useMemo } from "react";
import SidebarToggle from "./SidebarToggle";
// import { setCollapsed } from "../../Redux/reducers/appSlice";

const Sidebar = () => {
  const { platformPermissions } = useAppSelector((state) => state.user);
  const { collapsed } = useAppSelector((state) => state.app);

  const rbac = useMemo(
    () => ({
      view: platformPermissions.includes(platformAdminPermissions.viewPlatform),
      manage: platformPermissions.includes(
        platformAdminPermissions.managePlatform
      ),
    }),
    [platformPermissions]
  );

  return (
    <Box
      className={`sidebar ${collapsed ? "collapsed" : ""}`}
      sx={{
        "& .sider-menu": {
          color: "text.secondary",
        },
        "& .active.sider-menu": {
          backgroundColor: "secondary.main",
        },
        "& .user-management-menu": {
          color: "text.secondary",
        },
        "& .active.user-management-menu": {
          color: (theme) => theme.palette.primary.main,
        },
      }}
    >
      <SidebarToggle type="main" />
      <Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            paddingBottom: 2,
            margin: "10px 0px",
          }}
        >
          {!collapsed ? <Logo /> : <MahaloIcon />}
        </Box>
        <NavLink
          to="/app/studies"
          title="My Studies"
          className={({ isActive }) =>
            isActive ? "sider-menu active" : "sider-menu"
          }
        >
          <HomeIcon />
          {!collapsed && (
            <Typography variant="subtitle1" ml={1}>
              My Studies
            </Typography>
          )}
        </NavLink>
        {rbac.manage && (
          <NavLink
            to="/app/all-studies"
            title="All Studies"
            className={({ isActive }) =>
              isActive ? "sider-menu active" : "sider-menu"
            }
          >
            <AllStudiesIcon />
            {!collapsed && (
              <Typography variant="subtitle1" ml={1}>
                All Studies
              </Typography>
            )}
          </NavLink>
        )}
        {/* <NavLink
          to="/app/organisation"
          title="Organisation"
          className={({ isActive }) =>
            isActive ? "sider-menu active" : "sider-menu"
          }
        >
          <DashboardIcon />
          {!collapsed && (
            <Typography variant="subtitle1">Organisation</Typography>
          )}
        </NavLink> */}
        {rbac?.view && (
          <NavLink
            to="/app/features"
            title="Features"
            className={({ isActive }) =>
              isActive ? "sider-menu active" : "sider-menu"
            }
          >
            <FeaturesIcon />
            {!collapsed && (
              <Typography variant="subtitle1" ml={1}>
                Features
              </Typography>
            )}
          </NavLink>
        )}
        {rbac?.view && (
          <NavLink
            to="/app/platform-users"
            title="Users"
            className={({ isActive }) =>
              isActive ? "sider-menu active" : "sider-menu"
            }
          >
            <PlatformUsersIcon />
            {!collapsed && (
              <Typography variant="subtitle1" ml={1}>
                Users
              </Typography>
            )}
          </NavLink>
        )}
        {rbac?.view && (
          <NavLink
            to="/app/artifacts"
            title="Artifacts"
            className={({ isActive }) =>
              isActive ? "sider-menu active" : "sider-menu"
            }
          >
            <InstrumentLibraryIcon />
            {!collapsed && (
              <Typography variant="subtitle1" ml={1}>
                Artifacts
              </Typography>
            )}
          </NavLink>
        )}
      </Box>
      {/* <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <IconButton onClick={toggleCollapse}>
          {collapsed ? (
            <ChevronRight fontSize="large" />
          ) : (
            <ChevronLeft fontSize="large" />
          )}
        </IconButton>
      </Box> */}
      <VersionWrapper />
    </Box>
  );
};

export default Sidebar;
